@let isMobile = uiStore.isMobile();
@for (alertItem of alertList(); track alertItem) {
<div
  @slideX
  id="5D975619-1AEE"
  [ngClass]="{
    'right-[32px]': !isMobile,
    'px-[12px] right-0 left-0 w-screen max-w-screen flex items-center justify-center': isMobile
  }"
  class="absolute z-[101] bottom-[32px] transition-all duration-200 ease-[ease] -translate-y-[calc(var(--position)_*_100%)]"
>
  <lib-toast
    class="w-full"
    id="27EDA3B5-DEFE"
    (close)="removeAlert($event)"
    [alertItem]="alertItem"
  />
</div>
}
